import React from 'react';
interface IProps {
    onEvent: any;
    children: any;
    'data-attribute'?: any;
}

const EventHandler = ({ onEvent, children, 'data-attribute': dataAttribute }: IProps) => {


    const childArray = React.Children.toArray(children);

    const validChild = childArray.find(
        (child) => !(typeof child === 'string' && child.trim() === '')
    );

    if (!React.isValidElement(validChild)) return null;

    const propsToAdd = {
        tabIndex: 0,
        onClick: onEvent,
        onKeyDown: onEvent,
        'data-attribute': dataAttribute,
    };
    return React.cloneElement(validChild, propsToAdd);
};

export default EventHandler